var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import Toast from '../toast/Toast';
const noop = () => { };
const useToast = (_a) => {
    var { onClose, timeout } = _a, rest = __rest(_a, ["onClose", "timeout"]);
    const [visible, setVisibility] = React.useState(false);
    const timeoutRef = React.useRef(noop);
    useEffect(() => {
        if (timeout) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                setVisibility(false);
            }, timeout);
            return () => clearTimeout(timeoutRef.current);
        }
        return noop;
    }, [visible]);
    const hide = () => {
        setVisibility(false);
        if (typeof onClose === 'function') {
            onClose();
        }
    };
    const display = () => {
        setVisibility(true);
    };
    const ToastWithTimeout = visible ? React.createElement(Toast, Object.assign({ onClose: hide }, rest)) : null;
    return [ToastWithTimeout, display, hide];
};
export default useToast;
